import { useContext, useState, useRef, useLayoutEffect } from 'react';
import './Portfolio.css';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollSmoother from 'gsap/ScrollSmoother';
import SplitText from 'gsap/SplitText';

import { CustomCursorContext } from '../customCursor/context/CustomCursorContext';
import Modal from 'react-modal';
import PortFolioDetails from './PortfolioDetails';

Modal.setAppElement('#root');
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

const customStyles = {
	overlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'linear-gradient(180deg,rgba(35,37,49,.5),rgba(15,15,24,.5))',
		zIndex: 1000,
	},
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		padding: 0,
		border: 'none',
		borderRadius: '0',
		backgroundColor: 'rgba(0, 0, 0, 0.85)',
		zIndex: 1000,
	},
};

const PortfolioTemplate = ({ site, setHideHeader, index }) => {
	const { setTypeCursor } = useContext(CustomCursorContext);
	const [modal, setModal] = useState(false);
	const cardRef = useRef(null);
	const cardTitleRef = useRef(null);
	const closeModal = () => {
		document.body.style.overflow = 'unset';
		setHideHeader(false);
		setModal(false);
	};

	useLayoutEffect(() => {
		const card = cardRef.current;
		const title = cardTitleRef.current;
		card.addEventListener('mousemove', function (e) {
			const divRect = card.getBoundingClientRect();
			const x = e.clientX - divRect.left; // Position de la souris en x relative à l'élément
			const y = e.clientY - divRect.top; // Position de la souris en y relative à l'élément
			const width = divRect.width; // Largeur de l'élément
			const height = divRect.height; // Hauteur de l'élément

			// Coordonnées du centre de l'élément
			const centerX = width / 2;
			const centerY = height / 2;

			// Calcul de la distance de la position de la souris au centre de l'élément
			const distanceX = x - centerX;
			const distanceY = y - centerY;
			const distanceToCenter = Math.sqrt(Math.pow(distanceX, 2) + Math.pow(distanceY, 2));
			const maxDistance = Math.min(centerX, centerY);

			// Calculer l'effet de flou en utilisant une formule linéaire
			const maxBlur = 15; // Valeur maximale de flou au centre
			const blur = maxBlur * (1 - distanceToCenter / maxDistance);
			title.style.opacity = 1 - distanceToCenter / maxDistance / 2;

			// Appliquer l'effet de flou
			card.style.setProperty('--blur-card-element', `${blur}px`);
		});

		card.addEventListener('mouseout', function () {
			card.style.setProperty('--blur-card-element', `0px`);
			title.style.opacity = 0;
		});
	}, []);

	return (
		<>
			<div className="portfolio-element-container">
				{/* <div className="portfolio-element-title">{site.title}</div> */}
				<div className="portfolio-element-container-index">{index < 10 ? `0${index + 1}.` : index + 1 + ' '}</div>
				<div className="portfolio-element-content">
					<div
						className="portfolio-element-image"
						onMouseEnter={() => {
							setTypeCursor('cursor-hover');
						}}
						onMouseLeave={() => {
							setTypeCursor('default');
						}}
						onClick={() => {
							document.body.style.overflow = 'hidden';
							setHideHeader(true);
							setModal(true);
						}}
					>
						<img
							src={site.pictureUrl}
							alt={site.title}
						/>
						<div
							ref={cardRef}
							className="portfolio-element-image-blur"
						>
							<div
								ref={cardTitleRef}
								className="portfolio-element-image-blur-title"
							>
								{site.title}
							</div>
						</div>
						{/* <div className="portfolio-element-image-blur-title">
							
							<div></div>
						</div> */}
					</div>
					<div className="portfolio-element-card">
						<h1>{site.title}</h1>
						<p>{site.short}</p>
						<div className="live-demo-card-details">
							{site.repository.live && (
								<a
									href={site.repository.live}
									target="_blank"
									rel="noreferrer"
								>
									visit the website
								</a>
							)}
							{site.repository.frontend && (
								<a
									href={site.repository.frontend}
									target="_blank"
									rel="noreferrer"
								>
									<ion-icon name="logo-github"></ion-icon>
								</a>
							)}
						</div>
					</div>
					{/* <div className="portfolio-element-leftpannel">
						<div className="portfolio-element-description">{site.content.description}</div>
						<div className="stack-element">
							{site.techno.map((techno, index) => {
								return (
									<div
										key={index}
										className="techno-used"
									>
										<img
											src={techno}
											alt={techno}
										/>
									</div>
								);
							})}
						</div>
					</div> */}
				</div>
			</div>
			{modal && (
				<Modal
					isOpen={modal}
					style={customStyles}
					onRequestClose={closeModal}
				>
					<PortFolioDetails
						site={site}
						closeModal={closeModal}
					></PortFolioDetails>
				</Modal>
			)}
		</>
	);
};

export default PortfolioTemplate;
